// import React, { useState } from "react";
// import { motion } from "framer-motion";

// const About = () => {
//   const [activeSection, setActiveSection] = useState(null);

//   const sections = [
//     {
//       title: "Purpose",
//       icon: "🎯",
//       content: "This platform is created to help people understand and connect with the teachings of Sanatan Dharma through authentic scriptures such as the Vedas, Upanishads, Puranas, Bhagavad Gita, and other Hindu texts."
//     },
//     {
//       title: "How It Works",
//       icon: "⚙️",
//       content: "Information and answers are generated from scriptural knowledge, available texts, and traditional references. The goal is to offer spiritual guidance and awareness based on ancient wisdom in a modern and easy-to-understand format."
//     },
//     {
//       title: "Intent",
//       icon: "💫",
//       content: "The platform does not promote any personal belief, commercial religious activity, or replace qualified spiritual or legal advice. The sole intention is educational, spiritual, and knowledge-sharing."
//     },
//     {
//       title: "Respect for Traditions",
//       icon: "🙏",
//       content: "Scripture content shared is based on widely accepted interpretations. We respect all traditions and do not claim authority over any religious institution or community."
//     },
//     {
//       title: "No Guarantee of Accuracy",
//       icon: "📝",
//       content: "Interpretations may vary among scholars and traditions. Users are encouraged to consult qualified experts for critical decisions or detailed rituals."
//     }
//   ];

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 py-8 px-4 sm:px-6 lg:px-8">
//       <div className="max-w-6xl mx-auto">
//         {/* Header */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6 }}
//           className="text-center mb-12"
//         >
//           <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl mb-6 shadow-2xl">
//             <span className="text-2xl">🕉️</span>
//           </div>
//           <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent mb-4">
//             About Dharma Guide
//           </h1>
//           <p className="text-xl text-gray-300 max-w-2xl mx-auto">
//             Connecting ancient wisdom with modern questions through authentic scriptural guidance
//           </p>
//         </motion.div>

//         {/* Main Content */}
//         <div className="grid lg:grid-cols-2 gap-8 mb-12">
//           {/* Interactive Sections */}
//           <div className="space-y-6">
//             {sections.map((section, index) => (
//               <motion.div
//                 key={section.title}
//                 initial={{ opacity: 0, x: -20 }}
//                 animate={{ opacity: 1, x: 0 }}
//                 transition={{ duration: 0.5, delay: index * 0.1 }}
//                 className={`bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 cursor-pointer transition-all duration-300 border-2 ${
//                   activeSection === index 
//                     ? 'border-blue-500 shadow-2xl shadow-blue-500/20' 
//                     : 'border-gray-700 hover:border-blue-400/50'
//                 }`}
//                 onClick={() => setActiveSection(activeSection === index ? null : index)}
//               >
//                 <div className="flex items-center gap-4">
//                   <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center text-white text-lg">
//                     {section.icon}
//                   </div>
//                   <div className="flex-1">
//                     <h3 className="text-xl font-semibold text-white mb-2">{section.title}</h3>
//                     <p className="text-gray-300 leading-relaxed">
//                       {section.content}
//                     </p>
//                   </div>
//                 </div>
//               </motion.div>
//             ))}
//           </div>

//           {/* Feature Highlights */}
//           <motion.div
//             initial={{ opacity: 0, x: 20 }}
//             animate={{ opacity: 1, x: 0 }}
//             transition={{ duration: 0.6, delay: 0.3 }}
//             className="bg-gray-800/30 backdrop-blur-sm rounded-2xl p-8 border border-gray-700"
//           >
//             <h2 className="text-2xl font-bold text-white mb-6 text-center">Our Mission</h2>
            
//             <div className="space-y-6">
//               <div className="flex items-start gap-4">
//                 <div className="flex-shrink-0 w-10 h-10 bg-green-500/20 rounded-lg flex items-center justify-center text-green-400 text-lg">
//                   📚
//                 </div>
//                 <div>
//                   <h4 className="font-semibold text-white mb-2">Scripture-Based Guidance</h4>
//                   <p className="text-gray-300 text-sm">Answers rooted in authentic texts like Vedas, Upanishads, and Bhagavad Gita</p>
//                 </div>
//               </div>

//               <div className="flex items-start gap-4">
//                 <div className="flex-shrink-0 w-10 h-10 bg-blue-500/20 rounded-lg flex items-center justify-center text-blue-400 text-lg">
//                   🌍
//                 </div>
//                 <div>
//                   <h4 className="font-semibold text-white mb-2">Modern Understanding</h4>
//                   <p className="text-gray-300 text-sm">Ancient wisdom presented in contemporary language for today's challenges</p>
//                 </div>
//               </div>

//               <div className="flex items-start gap-4">
//                 <div className="flex-shrink-0 w-10 h-10 bg-purple-500/20 rounded-lg flex items-center justify-center text-purple-400 text-lg">
//                   ⚖️
//                 </div>
//                 <div>
//                   <h4 className="font-semibold text-white mb-2">Respectful Interpretation</h4>
//                   <p className="text-gray-300 text-sm">Honoring all traditions without claiming authority over any institution</p>
//                 </div>
//               </div>

//               <div className="flex items-start gap-4">
//                 <div className="flex-shrink-0 w-10 h-10 bg-yellow-500/20 rounded-lg flex items-center justify-center text-yellow-400 text-lg">
//                   🎓
//                 </div>
//                 <div>
//                   <h4 className="font-semibold text-white mb-2">Educational Focus</h4>
//                   <p className="text-gray-300 text-sm">Pure knowledge sharing</p>
//                 </div>
//               </div>
//             </div>

//             {/* Scriptures Showcase */}
//             <div className="mt-8 pt-6 border-t border-gray-700">
//               <h4 className="font-semibold text-white mb-4 text-center">Supported Scriptures</h4>
//               <div className="flex flex-wrap gap-3 justify-center">
//                 {['Vedas', 'Upanishads', 'Bhagavad Gita', 'Puranas', 'Ramayana', 'Mahabharata'].map((scripture) => (
//                   <span 
//                     key={scripture}
//                     className="px-3 py-1 bg-blue-500/20 text-blue-300 rounded-full text-sm border border-blue-500/30"
//                   >
//                     {scripture}
//                   </span>
//                 ))}
//               </div>
//             </div>
//           </motion.div>
//         </div>

//         {/* Bottom Note */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6, delay: 0.8 }}
//           className="text-center"
//         >
//           <div className="inline-block bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-2xl p-6 border border-blue-500/30">
//             <p className="text-gray-300 italic">
//               "This platform serves as a bridge between ancient wisdom and contemporary seekers, 
//               offering guidance while respecting the diversity of interpretations within Sanatan Dharma."
//             </p>
//           </div>
//         </motion.div>
//       </div>
//     </div>
//   );
// };

// export default About;


















// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { useNavigate } from "react-router-dom";

// const About = () => {
//   const navigate = useNavigate();
//   const [activeSection, setActiveSection] = useState(null);
//   const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

//   useEffect(() => {
//     window.scrollTo(0, 0);
//     const handleMouse = (e) => setMousePos({ x: e.clientX, y: e.clientY });
//     window.addEventListener("mousemove", handleMouse);
//     return () => window.removeEventListener("mousemove", handleMouse);
//   }, []);

//   const sections = [
//     {
//       title: "Our Purpose",
//       icon: "🎯",
//       color: "from-amber-500 to-orange-600",
//       glow: "rgba(251,191,36,0.15)",
//       content:
//         "DharmaAnswers was created to help every person — from a curious child to a seasoned scholar — connect with the eternal wisdom of Sanatan Dharma through authentic scriptures such as the Vedas, Upanishads, Puranas, Bhagavad Gita, Ramayana, Mahabharata, and more.",
//     },
//     {
//       title: "How It Works",
//       icon: "⚙️",
//       color: "from-cyan-500 to-blue-600",
//       glow: "rgba(6,182,212,0.15)",
//       content:
//         "Your question is analyzed by our AI system, which identifies the most relevant scriptures and generates a structured answer with authentic shlokas, their meanings, and practical guidance — all in your language, whether Hindi, English, Bengali, or others.",
//     },
//     {
//       title: "Our Intent",
//       icon: "💫",
//       color: "from-violet-500 to-purple-600",
//       glow: "rgba(139,92,246,0.15)",
//       content:
//         "This platform does not promote any personal belief, commercial religious activity, or replace qualified spiritual or legal advice. The sole intention is educational, spiritual, and knowledge-sharing — making the roots of Sanatan Dharma accessible to all.",
//     },
//     {
//       title: "Respect for Traditions",
//       icon: "🙏",
//       color: "from-emerald-500 to-teal-600",
//       glow: "rgba(16,185,129,0.15)",
//       content:
//         "Scripture content shared is based on widely accepted interpretations. We deeply respect all sampradayas and traditions, and do not claim authority over any religious institution or community. Diverse perspectives are acknowledged.",
//     },
//     {
//       title: "Honest Disclaimer",
//       icon: "📝",
//       color: "from-rose-500 to-pink-600",
//       glow: "rgba(244,63,94,0.15)",
//       content:
//         "Interpretations may vary among scholars and traditions. Every AI-generated answer carries a clear note encouraging users to consult qualified acharyas for critical decisions, rituals, or deeper study. We believe in transparency.",
//     },
//     {
//       title: "Original Concept",
//       icon: "🌱",
//       color: "from-lime-500 to-green-600",
//       glow: "rgba(132,204,22,0.15)",
//       content:
//         "DharmaAnswers was independently conceptualized, designed, and built by Krishna Kumar in 2025 - 2026 — starting as a personal mission to make Sanatan Dharma's wisdom reachable for everyone in the world. This is an original platform, first deployed publicly in 2026, combining AI technology with authentic scriptural guidance.",
//     },
//   ];

//   const milestones = [
//     { version: "v1.0.0", label: "Initial Launch", desc: "Core Q&A with scripture answers", icon: "🚀" },
//     { version: "v1.1.0", label: "Auth & Admin", desc: "JWT auth + role-based admin panel", icon: "🔐" },
//     { version: "v1.2.0", label: "Smart Caching", desc: "DB caching + Ask Shia hybrid feature", icon: "⚡" },
//     { version: "v1.3.0", label: "Audio Player", desc: "Multi-language voice — Hindi, Bengali, English & more", icon: "🔊", current: true },
//   ];

//   const scriptures = [
//     "Vedas", "Upanishads", "Bhagavad Gita", "Puranas",
//     "Ramayana", "Mahabharata", "Yoga Sutras",
//   ];

//   const features = [
//     { icon: "📚", title: "Scripture-Based", desc: "Authentic shlokas with meanings", color: "#f59e0b" },
//     { icon: "🌍", title: "Multi-Language", desc: "Hindi, English, Bengali & more", color: "#06b6d4" },
//     { icon: "🔊", title: "Listen Aloud", desc: "Audio playback in your language", color: "#8b5cf6" },
//     { icon: "🤝", title: "Ask Shia", desc: "Human + AI hybrid answers", color: "#10b981" },
//     { icon: "⚡", title: "Smart Cache", desc: "Instant answers for known questions", color: "#f43f5e" },
//     { icon: "🔐", title: "Secure", desc: "JWT auth & role-based access", color: "#3b82f6" },
//   ];

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg, #050510 0%, #0a0a1e 40%, #0d0a1a 100%)",
//         fontFamily: "'Cinzel', 'Georgia', serif",
//         position: "relative",
//         overflow: "hidden",
//       }}
//     >
//       {/* Ambient glow that follows mouse */}
//       <div
//         style={{
//           position: "fixed",
//           width: "600px",
//           height: "600px",
//           borderRadius: "50%",
//           background: "radial-gradient(circle, rgba(97,218,251,0.04) 0%, transparent 70%)",
//           left: mousePos.x - 300,
//           top: mousePos.y - 300,
//           pointerEvents: "none",
//           zIndex: 0,
//           transition: "left 0.3s ease, top 0.3s ease",
//         }}
//       />

//       {/* Background sacred geometry */}
//       <div style={{ position: "fixed", inset: 0, zIndex: 0, opacity: 0.04 }}>
//         <svg width="100%" height="100%">
//           <defs>
//             <pattern id="grid" width="80" height="80" patternUnits="userSpaceOnUse">
//               <path d="M 80 0 L 0 0 0 80" fill="none" stroke="#61dafb" strokeWidth="0.5" />
//             </pattern>
//           </defs>
//           <rect width="100%" height="100%" fill="url(#grid)" />
//         </svg>
//       </div>

//       <div style={{ position: "relative", zIndex: 1, maxWidth: "1100px", margin: "0 auto", padding: "60px 24px" }}>

//         {/* ── HERO ── */}
//         <motion.div
//           initial={{ opacity: 0, y: 40 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//           style={{ textAlign: "center", marginBottom: "80px" }}
//         >
//           {/* Om symbol */}
//           <motion.div
//             animate={{ rotate: [0, 5, -5, 0], scale: [1, 1.05, 1] }}
//             transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
//             style={{
//               display: "inline-flex", alignItems: "center", justifyContent: "center",
//               width: "100px", height: "100px",
//               background: "linear-gradient(135deg, rgba(97,218,251,0.15), rgba(148,187,233,0.1))",
//               border: "1px solid rgba(97,218,251,0.3)",
//               borderRadius: "24px",
//               fontSize: "48px",
//               marginBottom: "32px",
//               boxShadow: "0 0 40px rgba(97,218,251,0.2), inset 0 1px 0 rgba(255,255,255,0.1)",
//             }}
//           >
//             🕉️
//           </motion.div>

//           <h1
//             style={{
//               fontSize: "clamp(2.5rem, 6vw, 4.5rem)",
//               fontWeight: "700",
//               background: "linear-gradient(135deg, #61dafb 0%, #94bbe9 50%, #a78bfa 100%)",
//               WebkitBackgroundClip: "text",
//               WebkitTextFillColor: "transparent",
//               marginBottom: "20px",
//               lineHeight: 1.1,
//               letterSpacing: "-0.5px",
//             }}
//           >
//             About DharmaAnswers
//           </h1>

//           <p style={{ fontSize: "1.2rem", color: "#94bbe9", maxWidth: "600px", margin: "0 auto 32px", lineHeight: 1.7, fontFamily: "'Crimson Pro', Georgia, serif" }}>
//             Connecting the eternal wisdom of Sanatan Dharma with every soul seeking answers — in their language, at their level.
//           </p>

//           {/* Creator badge */}
//           <motion.div
//             initial={{ opacity: 0, scale: 0.9 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ delay: 0.4 }}
//             style={{
//               display: "inline-flex", alignItems: "center", gap: "12px",
//               padding: "12px 24px",
//               background: "linear-gradient(135deg, rgba(97,218,251,0.1), rgba(167,139,250,0.1))",
//               border: "1px solid rgba(97,218,251,0.25)",
//               borderRadius: "50px",
//               backdropFilter: "blur(10px)",
//             }}
//           >
//             <span style={{ fontSize: "20px" }}>🌱</span>
//             <span style={{ color: "#61dafb", fontSize: "14px", fontFamily: "'Crimson Pro', Georgia, serif" }}>
//               Original concept by <strong>Krishna Kumar</strong> &nbsp;·&nbsp; Est. 2026
//             </span>
//             <span style={{
//               background: "linear-gradient(135deg, #61dafb, #a78bfa)",
//               color: "#000",
//               fontSize: "11px",
//               fontWeight: "700",
//               padding: "3px 10px",
//               borderRadius: "20px",
//               fontFamily: "monospace",
//             }}>
//               v1.3.0
//             </span>
//           </motion.div>
//         </motion.div>

//         {/* ── FEATURES GRID ── */}
//         <motion.div
//           initial={{ opacity: 0, y: 30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.3 }}
//           style={{ marginBottom: "80px" }}
//         >
//           <h2 style={{ textAlign: "center", color: "#94bbe9", fontSize: "1rem", letterSpacing: "4px", textTransform: "uppercase", marginBottom: "40px", fontFamily: "monospace" }}>
//             Platform Features
//           </h2>
//           <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "16px" }}>
//             {features.map((f, i) => (
//               <motion.div
//                 key={f.title}
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.1 * i }}
//                 whileHover={{ y: -4, scale: 1.02 }}
//                 style={{
//                   background: "rgba(255,255,255,0.03)",
//                   border: `1px solid rgba(255,255,255,0.08)`,
//                   borderRadius: "16px",
//                   padding: "24px 16px",
//                   textAlign: "center",
//                   cursor: "default",
//                   transition: "all 0.3s ease",
//                 }}
//               >
//                 <div style={{ fontSize: "28px", marginBottom: "12px" }}>{f.icon}</div>
//                 <div style={{ color: f.color, fontSize: "13px", fontWeight: "700", marginBottom: "6px", fontFamily: "monospace" }}>{f.title}</div>
//                 <div style={{ color: "#6b7280", fontSize: "12px", fontFamily: "'Crimson Pro', Georgia, serif", lineHeight: 1.5 }}>{f.desc}</div>
//               </motion.div>
//             ))}
//           </div>
//         </motion.div>

//         {/* ── MAIN SECTIONS ── */}
//         <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "80px" }}>
//           {sections.map((section, index) => (
//             <motion.div
//               key={section.title}
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.1 * index }}
//               onClick={() => setActiveSection(activeSection === index ? null : index)}
//               style={{
//                 background: activeSection === index
//                   ? `radial-gradient(circle at top left, ${section.glow}, transparent 60%), rgba(255,255,255,0.04)`
//                   : "rgba(255,255,255,0.02)",
//                 border: `1px solid ${activeSection === index ? "rgba(97,218,251,0.3)" : "rgba(255,255,255,0.07)"}`,
//                 borderRadius: "20px",
//                 padding: "28px",
//                 cursor: "pointer",
//                 transition: "all 0.3s ease",
//                 gridColumn: index === 5 ? "1 / -1" : "auto",
//               }}
//               whileHover={{ scale: 1.01 }}
//             >
//               <div style={{ display: "flex", alignItems: "flex-start", gap: "16px" }}>
//                 <div style={{
//                   width: "48px", height: "48px", borderRadius: "14px", flexShrink: 0,
//                   background: `linear-gradient(135deg, ${section.color.replace("from-", "").replace(" to-", ", ")})`,
//                   display: "flex", alignItems: "center", justifyContent: "center",
//                   fontSize: "22px",
//                   boxShadow: `0 8px 20px ${section.glow}`,
//                 }}>
//                   {section.icon}
//                 </div>
//                 <div style={{ flex: 1 }}>
//                   <h3 style={{
//                     color: "#e2e8f0", fontSize: "1.05rem", fontWeight: "600",
//                     marginBottom: "8px", fontFamily: "'Cinzel', Georgia, serif",
//                   }}>
//                     {section.title}
//                   </h3>
//                   <AnimatePresence>
//                     <p style={{
//                       color: "#94a3b8", fontSize: "0.9rem", lineHeight: 1.75,
//                       fontFamily: "'Crimson Pro', Georgia, serif",
//                     }}>
//                       {section.content}
//                     </p>
//                   </AnimatePresence>
//                 </div>
//               </div>
//             </motion.div>
//           ))}
//         </div>

//         {/* ── VERSION TIMELINE ── */}
//         <motion.div
//           initial={{ opacity: 0, y: 30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.5 }}
//           style={{
//             background: "rgba(255,255,255,0.02)",
//             border: "1px solid rgba(97,218,251,0.15)",
//             borderRadius: "24px",
//             padding: "48px",
//             marginBottom: "80px",
//           }}
//         >
//           <h2 style={{ textAlign: "center", color: "#94bbe9", fontSize: "1rem", letterSpacing: "4px", textTransform: "uppercase", marginBottom: "48px", fontFamily: "monospace" }}>
//             Platform Journey
//           </h2>

//           <div style={{ position: "relative" }}>
//             {/* Timeline line */}
//             <div style={{
//               position: "absolute", left: "50%", top: 0, bottom: 0,
//               width: "1px",
//               background: "linear-gradient(to bottom, transparent, rgba(97,218,251,0.3), transparent)",
//               transform: "translateX(-50%)",
//             }} />

//             <div style={{ display: "flex", flexDirection: "column", gap: "40px" }}>
//               {milestones.map((m, i) => (
//                 <motion.div
//                   key={m.version}
//                   initial={{ opacity: 0, x: i % 2 === 0 ? -30 : 30 }}
//                   animate={{ opacity: 1, x: 0 }}
//                   transition={{ delay: 0.15 * i }}
//                   style={{
//                     display: "flex",
//                     justifyContent: i % 2 === 0 ? "flex-start" : "flex-end",
//                     position: "relative",
//                   }}
//                 >
//                   <div style={{
//                     width: "45%",
//                     background: m.current
//                       ? "linear-gradient(135deg, rgba(97,218,251,0.1), rgba(167,139,250,0.1))"
//                       : "rgba(255,255,255,0.03)",
//                     border: m.current ? "1px solid rgba(97,218,251,0.4)" : "1px solid rgba(255,255,255,0.07)",
//                     borderRadius: "16px",
//                     padding: "20px 24px",
//                   }}>
//                     <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
//                       <span style={{ fontSize: "20px" }}>{m.icon}</span>
//                       <span style={{
//                         fontFamily: "monospace", fontSize: "12px",
//                         color: m.current ? "#61dafb" : "#6b7280",
//                         fontWeight: "700",
//                       }}>{m.version}</span>
//                       {m.current && (
//                         <span style={{
//                           background: "linear-gradient(135deg, #61dafb, #a78bfa)",
//                           color: "#000", fontSize: "10px", fontWeight: "700",
//                           padding: "2px 8px", borderRadius: "10px",
//                         }}>CURRENT</span>
//                       )}
//                     </div>
//                     <div style={{ color: "#e2e8f0", fontSize: "14px", fontWeight: "600", marginBottom: "4px", fontFamily: "'Cinzel', Georgia, serif" }}>
//                       {m.label}
//                     </div>
//                     <div style={{ color: "#6b7280", fontSize: "13px", fontFamily: "'Crimson Pro', Georgia, serif" }}>
//                       {m.desc}
//                     </div>
//                   </div>

//                   {/* Center dot */}
//                   <div style={{
//                     position: "absolute", left: "50%", top: "50%",
//                     transform: "translate(-50%, -50%)",
//                     width: "12px", height: "12px", borderRadius: "50%",
//                     background: m.current ? "#61dafb" : "rgba(97,218,251,0.3)",
//                     boxShadow: m.current ? "0 0 12px rgba(97,218,251,0.6)" : "none",
//                     zIndex: 2,
//                   }} />
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//         </motion.div>

//         {/* ── SCRIPTURES ── */}
//         <motion.div
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ delay: 0.6 }}
//           style={{ textAlign: "center", marginBottom: "80px" }}
//         >
//           <h2 style={{ color: "#94bbe9", fontSize: "1rem", letterSpacing: "4px", textTransform: "uppercase", marginBottom: "32px", fontFamily: "monospace" }}>
//             Supported Scriptures
//           </h2>
//           <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "center" }}>
//             {scriptures.map((s, i) => (
//               <motion.span
//                 key={s}
//                 initial={{ opacity: 0, scale: 0.8 }}
//                 animate={{ opacity: 1, scale: 1 }}
//                 transition={{ delay: 0.05 * i }}
//                 whileHover={{ scale: 1.05, y: -2 }}
//                 style={{
//                   padding: "8px 20px",
//                   background: "rgba(97,218,251,0.08)",
//                   border: "1px solid rgba(97,218,251,0.2)",
//                   borderRadius: "50px",
//                   color: "#94bbe9",
//                   fontSize: "13px",
//                   cursor: "default",
//                   fontFamily: "'Cinzel', Georgia, serif",
//                   transition: "all 0.2s ease",
//                 }}
//               >
//                 {s}
//               </motion.span>
//             ))}
//           </div>
//         </motion.div>

//         {/* ── COPYRIGHT FOOTER ── */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.7 }}
//           style={{
//             textAlign: "center",
//             padding: "40px",
//             background: "linear-gradient(135deg, rgba(97,218,251,0.05), rgba(167,139,250,0.05))",
//             border: "1px solid rgba(97,218,251,0.15)",
//             borderRadius: "24px",
//           }}
//         >
//           <p style={{ color: "#94a3b8", fontStyle: "italic", marginBottom: "20px", fontFamily: "'Crimson Pro', Georgia, serif", fontSize: "1.05rem", lineHeight: 1.8 }}>
//             "This platform serves as a bridge between ancient wisdom and contemporary seekers,
//             offering guidance while respecting the diversity of interpretations within Sanatan Dharma."
//           </p>
//           <div style={{ display: "flex", justifyContent: "center", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
//             <span style={{ color: "#475569", fontSize: "13px", fontFamily: "monospace" }}>
//               © 2026 DharmaAnswers
//             </span>
//             <span style={{ color: "#334155" }}>·</span>
//             <span style={{ color: "#475569", fontSize: "13px", fontFamily: "monospace" }}>
//               Original concept & development by <span style={{ color: "#61dafb" }}>Krishna Kumar</span>
//             </span>
//             <span style={{ color: "#334155" }}>·</span>
//             <span style={{ color: "#475569", fontSize: "13px", fontFamily: "monospace" }}>
//               All rights reserved
//             </span>
//           </div>
//         </motion.div>

//       </div>

//       {/* Google Fonts */}
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=Crimson+Pro:ital,wght@0,400;0,600;1,400&display=swap');
//       `}</style>
//     </div>
//   );
// };

// export default About;















import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";

const About = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    {
      title: "Our Purpose",
      icon: "🎯",
      accent: "#61dafb",
      content:
        "DharmaAnswers was created to help every person — from a curious child to a seasoned scholar — connect with the eternal wisdom of Sanatan Dharma through authentic scriptures such as the Vedas, Upanishads, Puranas, Bhagavad Gita, Ramayana, Mahabharata, and more.",
    },
    {
      title: "How It Works",
      icon: "⚙️",
      accent: "#a78bfa",
      content:
        "Your question is analyzed by our AI system, which identifies the most relevant scriptures and generates a structured answer with authentic shlokas, their meanings, and practical guidance — all in your language, whether Hindi, English, Bengali, or others.",
    },
    {
      title: "Our Intent",
      icon: "💫",
      accent: "#34d399",
      content:
        "This platform does not promote any personal belief, commercial religious activity, or replace qualified spiritual advice. The sole intention is educational, spiritual, and knowledge-sharing — making the roots of Sanatan Dharma accessible to all.",
    },
    {
      title: "Respect for Traditions",
      icon: "🙏",
      accent: "#fbbf24",
      content:
        "Scripture content is based on widely accepted interpretations. We deeply respect all sampradayas and traditions, and do not claim authority over any religious institution or community.",
    },
    {
      title: "Honest Disclaimer",
      icon: "📝",
      accent: "#f87171",
      content:
        "Interpretations may vary among scholars and traditions. Every AI-generated answer carries a clear note encouraging users to consult qualified acharyas for critical decisions, rituals, or deeper study.",
    },
    {
      title: "Original Concept",
      icon: "🌱",
      accent: "#a3e635",
      content:
        "DharmaAnswers was independently conceptualized, designed, and built by Krishna Kumar starting November 2025, first publicly deployed January 2026. The platform's design, architecture, and core concept are proprietary intellectual property.",
    },
  ];

  const milestones = [
    { version: "v1.0.0", label: "Initial Launch", desc: "Core Q&A with scripture answers", icon: "🚀" },
    { version: "v1.1.0", label: "Auth & Admin", desc: "JWT auth + role-based admin panel", icon: "🔐" },
    { version: "v1.2.0", label: "Smart Caching", desc: "DB caching + Ask Shia hybrid feature", icon: "⚡" },
    { version: "v1.3.0", label: "Audio Player", desc: "Multi-language voice support", icon: "🔊", current: true },
  ];

  const scriptures = ["Vedas", "Upanishads", "Bhagavad Gita", "Puranas", "Ramayana", "Mahabharata", "Manusmriti", "Yoga Sutras"];

  const features = [
    { icon: "📚", title: "Scripture-Based", desc: "Authentic shlokas with meanings", color: "#f59e0b" },
    { icon: "🌍", title: "Multi-Language", desc: "Hindi, English, Bengali & more", color: "#06b6d4" },
    { icon: "🔊", title: "Listen Aloud", desc: "Audio in your language", color: "#8b5cf6" },
    { icon: "🤝", title: "Ask Shia", desc: "Human + AI hybrid answers", color: "#10b981" },
    { icon: "⚡", title: "Smart Cache", desc: "Instant answers", color: "#f43f5e" },
    { icon: "🔐", title: "Secure", desc: "JWT auth & role-based access", color: "#3b82f6" },
  ];

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(160deg, #04040f 0%, #080818 50%, #0a0612 100%)",
      fontFamily: "'Crimson Pro', Georgia, serif",
      position: "relative",
    }}>

      {/* ── CROSS BUTTON (fixed top right) ── */}
      <button
        onClick={() => navigate("/")}
        style={{
          position: "fixed", top: "16px", right: "16px", zIndex: 1000,
          width: "40px", height: "40px", borderRadius: "50%",
          background: "rgba(10,10,30,0.85)",
          border: "1px solid rgba(97,218,251,0.3)",
          color: "#94a3b8", fontSize: "22px", cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "center",
          backdropFilter: "blur(10px)",
          transition: "all 0.2s",
          lineHeight: 1,
        }}
        onMouseEnter={(e) => { e.currentTarget.style.color = "#fff"; e.currentTarget.style.borderColor = "rgba(97,218,251,0.6)"; }}
        onMouseLeave={(e) => { e.currentTarget.style.color = "#94a3b8"; e.currentTarget.style.borderColor = "rgba(97,218,251,0.3)"; }}
        aria-label="Close"
      >×</button>

      <div style={{ maxWidth: "900px", margin: "0 auto", padding: "48px 16px 60px" }}>

        {/* ── HERO ── */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          style={{ textAlign: "center", marginBottom: "56px" }}
        >
          <motion.div
            animate={{ y: [0, -5, 0] }}
            transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
            style={{
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              width: "80px", height: "80px", borderRadius: "20px",
              background: "linear-gradient(135deg, rgba(97,218,251,0.15), rgba(167,139,250,0.15))",
              border: "1px solid rgba(97,218,251,0.25)",
              fontSize: "36px", marginBottom: "24px",
              boxShadow: "0 0 40px rgba(97,218,251,0.15)",
            }}
          >🕉️</motion.div>

          <h1 style={{
            fontSize: "clamp(1.8rem, 6vw, 3.5rem)",
            fontWeight: "700",
            background: "linear-gradient(135deg, #61dafb 0%, #94bbe9 50%, #a78bfa 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            marginBottom: "16px",
            fontFamily: "'Cinzel', Georgia, serif",
            lineHeight: 1.2,
          }}>
            About DharmaAnswers
          </h1>

          <p style={{
            fontSize: "clamp(0.95rem, 3vw, 1.15rem)",
            color: "#94bbe9", maxWidth: "560px", margin: "0 auto 28px",
            lineHeight: 1.7,
          }}>
            Connecting the eternal wisdom of Sanatan Dharma with every soul seeking answers.
          </p>

          {/* Creator badge */}
          <div style={{
            display: "inline-flex", alignItems: "center", gap: "8px",
            padding: "10px 18px",
            background: "linear-gradient(135deg, rgba(97,218,251,0.08), rgba(167,139,250,0.08))",
            border: "1px solid rgba(97,218,251,0.2)",
            borderRadius: "50px",
            flexWrap: "wrap", justifyContent: "center",
          }}>
            <span style={{ fontSize: "16px" }}>🌱</span>
            <span style={{ color: "#61dafb", fontSize: "13px", fontFamily: "monospace", textAlign: "center" }}>
              Original concept by <strong>Krishna Kumar</strong>
            </span>
            <span style={{ color: "#475569", fontSize: "12px", fontFamily: "monospace" }}>· Nov 2025</span>
            <span style={{
              background: "linear-gradient(135deg, #61dafb, #a78bfa)",
              color: "#000", fontSize: "11px", fontWeight: "700",
              padding: "2px 8px", borderRadius: "20px", fontFamily: "monospace",
            }}>v1.3.0</span>
          </div>
        </motion.div>

        {/* ── FEATURES GRID ── */}
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }} style={{ marginBottom: "60px" }}>
          <h2 style={{ textAlign: "center", color: "#475569", fontSize: "0.75rem", letterSpacing: "4px", textTransform: "uppercase", marginBottom: "28px", fontFamily: "monospace" }}>
            Platform Features
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))", gap: "12px" }}>
            {features.map((f, i) => (
              <motion.div
                key={f.title}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.07 * i }}
                style={{
                  background: "rgba(255,255,255,0.02)",
                  border: "1px solid rgba(255,255,255,0.07)",
                  borderRadius: "14px",
                  padding: "20px 12px",
                  textAlign: "center",
                }}
              >
                <div style={{ fontSize: "24px", marginBottom: "8px" }}>{f.icon}</div>
                <div style={{ color: f.color, fontSize: "12px", fontWeight: "700", marginBottom: "5px", fontFamily: "monospace" }}>{f.title}</div>
                <div style={{ color: "#475569", fontSize: "11px", lineHeight: 1.5 }}>{f.desc}</div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* ── SECTIONS ── */}
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }} style={{ marginBottom: "60px" }}>
          <h2 style={{ textAlign: "center", color: "#475569", fontSize: "0.75rem", letterSpacing: "4px", textTransform: "uppercase", marginBottom: "28px", fontFamily: "monospace" }}>
            About Us
          </h2>
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {sections.map((section, index) => (
              <motion.div
                key={section.title}
                initial={{ opacity: 0, y: 14 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.06 * index }}
                onClick={() => setActiveSection(activeSection === index ? null : index)}
                style={{
                  background: activeSection === index ? "rgba(255,255,255,0.04)" : "rgba(255,255,255,0.02)",
                  border: `1px solid ${activeSection === index ? section.accent + "40" : "rgba(255,255,255,0.07)"}`,
                  borderRadius: "16px",
                  padding: "18px 20px",
                  cursor: "pointer",
                  transition: "all 0.3s",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <div style={{
                    width: "40px", height: "40px", borderRadius: "11px", flexShrink: 0,
                    background: `${section.accent}15`,
                    border: `1px solid ${section.accent}25`,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: "18px",
                  }}>{section.icon}</div>

                  <h3 style={{
                    flex: 1,
                    color: activeSection === index ? section.accent : "#cbd5e1",
                    fontSize: "clamp(0.9rem, 3vw, 1rem)",
                    fontWeight: "600",
                    fontFamily: "'Cinzel', Georgia, serif",
                    transition: "color 0.3s",
                  }}>{section.title}</h3>

                  <span style={{
                    color: "#475569", fontSize: "18px", flexShrink: 0,
                    transition: "transform 0.3s", display: "inline-block",
                    transform: activeSection === index ? "rotate(180deg)" : "none",
                  }}>⌄</span>
                </div>

                <AnimatePresence>
                  {activeSection === index && (
                    <motion.p
                      initial={{ opacity: 0, height: 0, marginTop: 0 }}
                      animate={{ opacity: 1, height: "auto", marginTop: "14px" }}
                      exit={{ opacity: 0, height: 0, marginTop: 0 }}
                      style={{
                        color: "#94a3b8", fontSize: "clamp(0.88rem, 2.5vw, 0.95rem)",
                        lineHeight: 1.8, overflow: "hidden",
                        paddingLeft: "52px",
                      }}
                    >{section.content}</motion.p>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* ── VERSION TIMELINE ── */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          style={{
            background: "rgba(255,255,255,0.02)",
            border: "1px solid rgba(97,218,251,0.12)",
            borderRadius: "20px",
            padding: "36px 24px",
            marginBottom: "60px",
          }}
        >
          <h2 style={{ textAlign: "center", color: "#475569", fontSize: "0.75rem", letterSpacing: "4px", textTransform: "uppercase", marginBottom: "36px", fontFamily: "monospace" }}>
            Platform Journey
          </h2>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {milestones.map((m, i) => (
              <motion.div
                key={m.version}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.1 * i }}
                style={{
                  display: "flex", gap: "16px", alignItems: "flex-start",
                  background: m.current ? "rgba(97,218,251,0.06)" : "rgba(255,255,255,0.02)",
                  border: `1px solid ${m.current ? "rgba(97,218,251,0.3)" : "rgba(255,255,255,0.05)"}`,
                  borderRadius: "14px",
                  padding: "16px 20px",
                }}
              >
                <div style={{
                  width: "36px", height: "36px", borderRadius: "50%",
                  background: m.current ? "rgba(97,218,251,0.2)" : "rgba(255,255,255,0.05)",
                  border: `1px solid ${m.current ? "rgba(97,218,251,0.4)" : "rgba(255,255,255,0.1)"}`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: "16px", flexShrink: 0,
                }}>{m.icon}</div>

                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap", marginBottom: "4px" }}>
                    <span style={{ fontFamily: "monospace", fontSize: "11px", color: m.current ? "#61dafb" : "#475569", fontWeight: "700" }}>
                      {m.version}
                    </span>
                    {m.current && (
                      <span style={{
                        background: "linear-gradient(135deg, #61dafb, #a78bfa)",
                        color: "#000", fontSize: "9px", fontWeight: "700",
                        padding: "2px 7px", borderRadius: "10px",
                      }}>CURRENT</span>
                    )}
                  </div>
                  <div style={{ color: "#e2e8f0", fontSize: "0.9rem", fontWeight: "600", marginBottom: "3px", fontFamily: "'Cinzel', Georgia, serif" }}>
                    {m.label}
                  </div>
                  <div style={{ color: "#475569", fontSize: "0.85rem" }}>{m.desc}</div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* ── SCRIPTURES ── */}
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }} style={{ textAlign: "center", marginBottom: "60px" }}>
          <h2 style={{ color: "#475569", fontSize: "0.75rem", letterSpacing: "4px", textTransform: "uppercase", marginBottom: "24px", fontFamily: "monospace" }}>
            Supported Scriptures
          </h2>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "center" }}>
            {scriptures.map((s) => (
              <span key={s} style={{
                padding: "7px 16px",
                background: "rgba(97,218,251,0.07)",
                border: "1px solid rgba(97,218,251,0.18)",
                borderRadius: "50px",
                color: "#94bbe9",
                fontSize: "clamp(11px, 2.5vw, 13px)",
                fontFamily: "'Cinzel', Georgia, serif",
              }}>{s}</span>
            ))}
          </div>
        </motion.div>

        {/* ── COPYRIGHT FOOTER ── */}
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.6 }} style={{
          textAlign: "center",
          padding: "28px 16px",
          background: "linear-gradient(135deg, rgba(97,218,251,0.05), rgba(167,139,250,0.05))",
          border: "1px solid rgba(97,218,251,0.12)",
          borderRadius: "16px",
        }}>
          <p style={{ color: "#94a3b8", fontStyle: "italic", marginBottom: "16px", fontSize: "clamp(0.9rem, 2.5vw, 1rem)", lineHeight: 1.8 }}>
            "A bridge between ancient wisdom and contemporary seekers — respecting all interpretations within Sanatan Dharma."
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "6px", alignItems: "center", flexWrap: "wrap" }}>
            <span style={{ color: "#334155", fontSize: "12px", fontFamily: "monospace" }}>© 2025–2026 DharmaAnswers</span>
            <span style={{ color: "#1e293b" }}>·</span>
            <span style={{ color: "#334155", fontSize: "12px", fontFamily: "monospace" }}>
              Original concept by <span style={{ color: "#61dafb" }}>Krishna Kumar</span>
            </span>
            <span style={{ color: "#1e293b" }}>·</span>
            <span style={{ color: "#334155", fontSize: "12px", fontFamily: "monospace" }}>All rights reserved</span>
          </div>
        </motion.div>

      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=Crimson+Pro:ital,wght@0,400;0,600;1,400&display=swap');
        * { box-sizing: border-box; }
      `}</style>
    </div>
  );
};

export default About;